"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
function getTimeUntilMidnight(): {
  hours: number;
  minutes: number;
  seconds: number;
} {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(24, 0, 0, 0);
  let diff = midnight.getTime() - now.getTime();

  // If somehow past midnight (edge case), show full day
  if (diff <= 0) {
    diff = 24 * 60 * 60 * 1000;
  }
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(diff % (1000 * 60) / 1000);
  return {
    hours,
    minutes,
    seconds
  };
}
function pad(n: number): string {
  return n.toString().padStart(2, "0");
}
export function SaleBannerCountdown() {
  const $ = _c(20);
  const [time, setTime] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setTime(getTimeUntilMidnight());
      const interval = setInterval(() => {
        setTime(getTimeUntilMidnight());
      }, 1000);
      return () => clearInterval(interval);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (time === null) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        fontWeight: 700,
        fontVariantNumeric: "tabular-nums"
      };
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <span style={{
        fontSize: "0.85em",
        marginRight: "0.25em"
      }}>h</span>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <span style={{
        fontSize: "0.85em",
        marginRight: "0.25em"
      }}>m</span>;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <span style={t2}><span>00{t3}00{t4}00<span style={{
            fontSize: "0.85em"
          }}>s</span></span></span>;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    return t5;
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontWeight: 700,
      fontVariantNumeric: "tabular-nums"
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== time.hours) {
    t3 = pad(time.hours);
    $[7] = time.hours;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span style={{
      fontSize: "0.85em",
      marginRight: "0.25em"
    }}>h</span>;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== time.minutes) {
    t5 = pad(time.minutes);
    $[10] = time.minutes;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span style={{
      fontSize: "0.85em",
      marginRight: "0.25em"
    }}>m</span>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== time.seconds) {
    t7 = pad(time.seconds);
    $[13] = time.seconds;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span style={{
      fontSize: "0.85em"
    }}>s</span>;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t3 || $[17] !== t5 || $[18] !== t7) {
    t9 = <span style={t2}><span>{t3}{t4}{t5}{t6}{t7}{t8}</span></span>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t7;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}